'use strict';

var cleave = require('../components/cleave');
var formValidation = require('../components/formValidation');
var processInclude = require('base/util');
var productBase = require('../product/base');
var utils = require('../utils');
var dataLayer = window.dataLayer;

/**
 * formatting for PUR birth date
 */
function handleDateField() {
    if ($('[name$="_powerUpRewardsProfile_birthDate"]').length > 0) {
        cleave.handleDateField('[name$="_powerUpRewardsProfile_birthDate"]', ['m', 'd']);
    }
}

/**
 * formatting for phone number field
 */
function handlePhoneNumber() {
    if ($('[name$="_powerUpRewardsProfile_phone"]').length > 0) {
        cleave.handlePhoneNumber('[name$="_powerUpRewardsProfile_phone"]', 'US');
    }
}

/**
 * show PowerUp Rewards Player Enrollment dialog
 * @param {jQuery} dialog - The dialog
 */
function showPlayerEnrollmentDialog(dialog) {
    if ($('#purPlayerModal').length > 0) {
        $('#purPlayerModal').remove();
    }

    $('body').append(dialog);
    $('#purPlayerModal').modal('show');

    handleDateField();
    handlePhoneNumber();
    processInclude(require('../components/input'));

    $('#pur-player-form').on('submit', function (e) {
        var $form = $(this);
        e.preventDefault();
        $form.spinner().start();
        $form.find('.user-time-zone').val(new Date().getTimezoneOffset());
        $.ajax({
            url: $form.attr('action'),
            type: 'post',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.redirectUrl) {
                    $('body').trigger('purlanding:playerFormSubmit');
                    $('body').trigger('purlanding:playerCreateAccount');
                    $('body').trigger('confirmation:signUp');
                    window.location.href = data.redirectUrl;
                } else if (!data.success) {
                    formValidation($form, data);
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                }
            },
            complete: function () {
                $form.spinner().stop();
            }
        });
        return false;
    });

    $('#purPlayerModal').on('click', '.btn-cancel', (function () {
        $('#purPlayerModal').modal('hide');
    }));
}

/**
 * Renders a modal window that displays PUR enrollement error/success message to customer
 */
function showEnrollmentStatusDialog() {
    var textHeader = $('.pur-enrollment-dialog-status').data('heading');
    var textBody = $('.pur-enrollment-dialog-status').data('body');

    if ($('#purEnrollmentStatusModal').length !== 0) {
        $('#purEnrollmentStatusModal').remove();
    }
    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="purEnrollmentStatusModal" role="dialog">'
        + '<div class="modal-dialog">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '<div class="modal-title"><h5>' + textHeader + '</h5></div>'
        + '<button type="button" class="close pull-right" data-dismiss="modal">'
        + '&times;'
        + '</button>'
        + '</div>'
        + '<div class="modal-body">' + textBody + '</div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('#purEnrollmentStatusModal').spinner().start();
    $('body').append(htmlString);

    $('#purEnrollmentStatusModal').modal('show');
    $.spinner().stop();
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const enrollStatus = urlParams.get('purEnrollmentStatus') || urlParams.get('accountLinkingStatus');
    var urlToReload = window.location.href.split('?')[0];
    // 01 is tibco timed out , 02 is error, 04 is tibco success but not activated, accountLinked for successful account linking
    if (enrollStatus === '01' || enrollStatus === '04' || enrollStatus === 'accountLinked') {
        $('#purEnrollmentStatusModal').find('.close').on('click', function () {
            $.ajax({
                url: urlToReload,
                success: function () {
                    window.location.replace(urlToReload);
                }
            });
        });
    }
    utils.handleProSubscriptionAutoRenewalEvents();
}

/**
 * @param {number} countUpdated - update position for components
 * Dynamic Impression tracking for home page components
*/
function dynamicImpressionTracking(countUpdated) {
    let countCheck = countUpdated;
    let $el = $('.sticky-banner, .full-bleed-hero, .section-highlight-pur-cta, .pro-upsell');
    $('.sticky-banner, .full-bleed-hero, .section-highlight-pur-cta, .pro-upsell').each(function () {
        $el = $(this);
        if (!$el.attr('data-viewed')) {
            const config = {
                rootMargin: '0px 0px 0px 0px',
                threshold: 0
            };
            let observer = new IntersectionObserver((entries, self) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        var arryData = [];
                        var promoData = [];
                        var promoCount = 0;
                        var $this = $(entry.target);
                        var $globalHeadingVar = $this.data('creative-name');
                        var $globalComponentType = $this.data('component-name') || '';
                        var isProductTile = false;
                        $this.find('.amplience-card a').each(function () {
                            let $carouselElement = $(this).closest('.slick-slider');
                            let $clonedSlide = $(this).closest('.slick-cloned');
                            var headingdata = $globalHeadingVar;
                            // Removing cloned slides from carousel
                            if (!$carouselElement.length || ($carouselElement.length && !$clonedSlide.length)) {
                                var $localHeadingVar;
                                if (!headingdata) {
                                    if ($(this).hasClass('pd-homepage-tile')) {
                                        $localHeadingVar = $(this).parents('.pd-component').find('.headingtext');
                                    } else {
                                        $localHeadingVar = $(this).parents('.amplience-carousel').find('.heading');
                                    }
                                    headingdata = $localHeadingVar.length ? $.trim($localHeadingVar.text()) : 'Hero Carousel';
                                }
                                $(this).attr('data-position', countCheck);
                                if ($(this).hasClass('view-cart-link') || !$(this).siblings('.view-cart-link').length) {
                                    countCheck++;
                                    promoCount++;
                                }
                                $(this).attr('data-promo-position', promoCount);
                                isProductTile = $(this).hasClass('product-tile-link');
                                if (!$(this).hasClass('d-none')) {
                                    if ($(this).data('ci-tracking') || $(this).data('campaign-name')) {
                                        if ($globalComponentType) {
                                            arryData.push({
                                                id: $(this).data('ci-tracking'),
                                                name: $(this).data('campaign-name'),
                                                creative: headingdata,
                                                position: $(this).attr('data-position')
                                            });
                                            promoData.push({
                                                id: isProductTile ? $(this).attr('data-tracking-id') : $(this).data('ci-tracking'),
                                                name: isProductTile ? $(this).attr('data-tracking-name') : $(this).data('campaign-name'),
                                                creative: headingdata,
                                                position: promoCount
                                            });
                                        } else {
                                            arryData.push({
                                                id: $(this).data('ci-tracking'),
                                                name: $(this).data('campaign-name'),
                                                creative: headingdata,
                                                position: $(this).attr('data-position')
                                            });
                                            promoData.push({
                                                id: $(this).data('ci-tracking'),
                                                name: $(this).data('campaign-name'),
                                                creative: headingdata,
                                                position: promoCount
                                            });
                                        }
                                    } else if ($globalComponentType) {
                                        arryData.push({
                                            id: $(this).find('a').data('ci-tracking'),
                                            name: $(this).find('a').data('campaign-name'),
                                            creative: headingdata,
                                            position: $(this).attr('data-position')
                                        });
                                        promoData.push({
                                            id: isProductTile ? $(this).attr('data-tracking-id') : $(this).find('a').data('ci-tracking'),
                                            name: isProductTile ? $(this).attr('data-tracking-name') : $(this).find('a').data('campaign-name'),
                                            creative: headingdata,
                                            position: promoCount
                                        });
                                    } else {
                                        arryData.push({
                                            id: $(this).find('a').data('ci-tracking'),
                                            name: $(this).find('a').data('campaign-name'),
                                            creative: headingdata,
                                            position: $(this).attr('data-position')
                                        });
                                        promoData.push({
                                            id: $(this).find('a').data('ci-tracking'),
                                            name: $(this).find('a').data('campaign-name'),
                                            creative: headingdata,
                                            position: promoCount
                                        });
                                    }
                                }
                            }

                            $(this).on('click', function () {
                                var clickArryData = [];
                                clickArryData.push({
                                    id: $(this).data('ci-tracking'),
                                    name: $(this).data('campaign-name'),
                                    creative: headingdata,
                                    position: $(this).attr('data-position')
                                });

                                var ClickEventObj = {
                                    event: 'Banner click',
                                    componentType: $globalComponentType,
                                    ecommerce: {
                                        promoView: {
                                            promotions: clickArryData
                                        }
                                    }
                                };
                                window.dataLayer.push(ClickEventObj);
                            });
                        });

                        var obj = {
                            event: 'Banner Impression',
                            componentType: $globalComponentType,
                            ecommerce: {
                                promoView: {
                                    promotions: arryData
                                }
                            }
                        };

                        window.dataLayer.push(obj);
                        self.unobserve(entry.target);
                        $this.attr('data-viewed', true);
                        $('.page-designer.home-page-redesign').attr('count-update', countCheck);
                    }
                });
            }, config);
            observer.observe($el[0]);
        }
    });
}

module.exports = {
    methods: {
        showPlayerEnrollmentDialog: showPlayerEnrollmentDialog
    },

    // Adding event for analytic persistentLogin
    persitentLoginAnalytics: function () {
        $(document).on('change', '.js-remember-me', function () {
            var rememberMe = $(this).prop('checked');
            dataLayer.push({
                event: 'Persistent Login',
                eventAction: rememberMe ? 'opt in' : 'opt out'
            });
        });
    },

    phoneNumberValidation: function () {
        $(document).on('blur', '#pur-player-form #phone', function () {
            var $this = $(this);
            var $inputFormGroup = $this.parents('.form-group');
            var $errorLabel = $inputFormGroup.find('.invalid-feedback');
            var minLength = parseInt($this.attr('minlength'), 10);
            var fieldLength = $this.val().replace(/\s+/g, '').length;
            var $errorText = $this.attr('data-error');
            if (fieldLength < minLength) {
                $errorLabel.text($errorText);
                $this.addClass('is-invalid');
                $inputFormGroup.removeClass('is-valid');
            } else {
                $errorLabel.text('');
                $inputFormGroup.addClass('is-valid');
                $this.removeClass('is-invalid');
            }
        });
    },

    handleDateField: handleDateField,

    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function () {
            //$.spinner().start();
        });
    },

    showPowerUpRewardsEnrollmentStatus: function () {
        if ($('.pur-enrollment-dialog-status').length > 0 && $('.pur-enrollment-dialog-status').data('show') === true) {
            showEnrollmentStatusDialog();
        }
    },

    submitPowerUpRewardsProfile: function () {
        $('body').off('submit', 'form.pur-profile-setup-form').on('submit', 'form.pur-profile-setup-form', function (e) {
            var $form = $(this);
            e.preventDefault();
            var url = $form.attr('action');
            $form.spinner().start();
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                    if (!data.success) {
                        formValidation($form, data);
                    } else if (data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                    }
                },
                error: function (err) {
                    if (err.responseJSON && err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                },
                complete: function () {
                    $form.spinner().stop();
                }
            });
            return false;
        });
    },

    onPlayerEnrollClick: function () {
        $('body').off('pur:player-enroll').on('pur:player-enroll', function (e, data) {
            var url = data.url;
            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            const oid = urlParams.get('ID') || '';
            if (url) {
                $.spinner().start();

                $.get(url, {
                    pid: data.pid,
                    orderid: oid
                }).done(function (dialog) {
                    $('body').trigger('purlanding:playerDataUpload');
                    showPlayerEnrollmentDialog(dialog); //eslint-disable-line
                }).always(function () {
                    $.spinner().stop();
                });
            }
        });
    },

    onProRenewClick: function () {
        $('body').off('pur:pro-renew').on('pur:pro-renew', function (e, data) {
            e.preventDefault();

            $.spinner().start();
            var addToCartUrl = data.url;
            var form = {
                pid: data.pid,
                options: data.options,
                isRenewFlow: true
            };

            if (addToCartUrl) {
                $('body').trigger('pur:beforeAddToCart', this);
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (response) {

                        var $proRenewModal = $('#proRenewModal');
                        if ($('.cart-pro-upsell-content').length && $proRenewModal.hasClass('show')) {
                            $proRenewModal.modal('hide');
                            window.location.reload();
                        } else {
                            productBase.methods.handlePostCartAdd(response);
                        }
                        if (!response.error) {
                            $('body').trigger('product:afterAddToCart', data);
                        }
                        if ($('.pur-renew-redesign').length) {
                            $('.pur-renew-redesign').remove();
                        }
                        $('#proRenewModal').modal('hide');
                        $('#renewPowerUpRewardsModal').modal('hide');
                    },
                    complete: function () {
                        $.spinner().stop();
                    }
                });
            } else {
                $.spinner().stop();
            }
        });
    },

    onProEnrollClick: function () {
        $('body').off('pur:pro-enroll').on('pur:pro-enroll', function (e, data) {
            e.preventDefault();

            $.spinner().start();
            var addToCartUrl = data.url;
            var form = {
                pid: data.pid,
                options: data.options
            };

            if (addToCartUrl) {
                $('body').trigger('pur:beforeAddToCart', this);
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (response) {
                        var $playerUpgradeModal = $('#playerUpgradeModal');
                        var $subscriptionPurUpgrade = $('.subscriptions-card .js-pur-upgrade');
                        var $subscriptionProUpsellNew = $('#subscription-pro-upsell-content');
                        if (($('.cart-pro-upsell-content').length || $('#cart-pro-upsell-content-redesign').length) && $playerUpgradeModal.hasClass('show')) {
                            $playerUpgradeModal.modal('hide');
                            window.location.reload();
                        } else {
                            productBase.methods.handlePostCartAdd(response);
                        }
                        if ($('js-my-account-header .js-pur-upgrade').length && !$subscriptionProUpsellNew.length) {
                            $('.dashboard-upgrade-banner').addClass('d-none');
                            $('js-my-account-header .js-pur-upgrade').remove();
                        }
                        if ($subscriptionPurUpgrade.length && !$subscriptionProUpsellNew.length) {
                            $subscriptionPurUpgrade.remove();
                        }
                        let isPROItemInCart = $('#isPROItemInCart');
                        let $viewCartLink = $('.view-cart-link');

                        if ($subscriptionProUpsellNew.length) {
                            $('.pro-price-container').toggleClass('d-none d-flex');
                            $('.view-cart-link, .pur-cart-message').removeClass('d-none');
                            $('.js-pur-upgrade').addClass('d-none');
                        } else if (isPROItemInCart.length && isPROItemInCart.val() === 'false' && $viewCartLink.length) {
                            $('.js-pur-upgrade').addClass('d-none');
                            $('.view-cart-link').removeClass('d-none');
                        }
                        if (!response.error) {
                            $('body').trigger('product:afterAddToCart', data);
                            $('body').trigger('product:afterAddToCartDetails', { data: data, label: $('.pur-landing-page').length ? 'power up rewards' : 'order confirmation' });
                            $('body').trigger('purlanding:proCreateAccount');
                        }
                    },
                    complete: function () {
                        $.spinner().stop();
                    }
                });
            } else {
                $.spinner().stop();
            }
        });

        $(document).on('hide.bs.modal', '.PUR-redesignATCModal', function () {
            if ($('.product-detail-redesign').length) {
                $('.PUR-redesignATCModal').remove();
            }
        });
    },

    purLanding: function () {
        var $stickyHeader = $('.pur-sticky-header');
        var $stickyHeaderLinks = $('.pur-sticky-header .sticky-links');
        var $sectionLinks = $('.pur-sticky-header .section-links li');
        var $gridheading = $('.pur-member-benefits .grid-heading');
        var $purProductGridSelector = $('#benefits');
        var $productGridLabels = $('.pur-member-benefits .benefit-label');

        $('body').off('click', '.view-more-link').on('click', '.view-more-link', function () {
            event.preventDefault();
            var $productCard = $(this).parents('.pur-product-card');
            $productCard.toggleClass('active');
            var $viewlink = $(this).find('a');
            $productCard.find('.view-more-details').removeClass('d-none');
            if ($productCard.hasClass('active')) {
                $viewlink.find('.view-more-text').addClass('d-none');
                $viewlink.find('.view-less-text').removeClass('d-none');
            } else {
                $viewlink.find('.view-less-text').addClass('d-none');
                $viewlink.find('.view-more-text').removeClass('d-none');
            }
        });

        $('body').off('click', '.pro-tile').on('click', '.pro-tile', function () {
            $('.pro-tile').find('input[type=radio]').removeAttr('checked').prop('checked', false);
            $(this).find('input[type=radio]').attr('checked', true).prop('checked', true);
            $('.pro-tile').removeClass('selected');
            $(this).addClass('selected');
        });

        $('body').off('click', '.pro-member-button, .join-now-button, .header-join-now-link').on('click', '.pro-member-button, .join-now-button, .header-join-now-link', function () {
            var gridHeaderHeight = $gridheading.outerHeight() || 0;
            setTimeout(function () {
                window.scroll(0, ($purProductGridSelector.offset().top - $stickyHeaderLinks.outerHeight()) - gridHeaderHeight);
            }, 0);
            if (utils.mediaBreakpointDown('md') && $(this).hasClass('header-join-now-link')) {
                $stickyHeader.find('.navbar-collapse').removeClass('show');
            }
        });

        $('body').off('click', '.pur-member-benefits .benefit-label a').on('click', '.pur-member-benefits .benefit-label a', function () {
            var sectionId = $(this).find('a')[0].hash;
            var gridHeaderHeight = $gridheading.outerHeight() || 0;
            setTimeout(function () {
                window.scroll(0, $(sectionId).offset().top - $stickyHeaderLinks.outerHeight() - gridHeaderHeight);
            }, 0);
        });

        $(window).on('load', function () {
            $sectionLinks.each(function () {
                var sectionId = $(this).find('a')[0].hash;
                if ($(sectionId).length) {
                    $(this).removeClass('d-none');
                }
            });

            $productGridLabels.each(function () {
                var link = $(this).find('a');
                if (link.length) {
                    var section = link[0].hash;
                    if ($(section).length === 0) {
                        $(link).attr('href', '');
                        $(link).css('text-decoration', 'none');
                    }
                }
            });

            if ($('#isPlayerMember').val() === 'true') {
                $('.player-member-heading').removeClass('d-none');
                $('.player-atc-button, .player-join-now-link ').addClass('d-none');
                $('.grid-footer .value:first .value-tile').addClass('d-none');
            } else {
                $('.player-atc-button, .player-join-now-link ').removeClass('d-none');
                $('.grid-footer .value:first .value-tile').removeClass('d-none');
                $('.player-member-heading').addClass('d-none');
            }
        });

        $(window).off('scroll.productsticky').on('scroll.productsticky', function () {
            if (!$('.hero-carousel-redesign').visible(true)) {
                $stickyHeaderLinks.removeClass('d-none');
                if (utils.mediaBreakpointDown('md')) {
                    $('.navbar-collapse').addClass('collapse');
                }
            } else {
                $stickyHeaderLinks.addClass('d-none');
                $('.navbar-collapse').removeClass('show');
            }
        });

        $('body').off('click', '.pur-sticky-header .section-links li').on('click', '.pur-sticky-header .section-links li', function () {
            var sectionId = $(this).find('a')[0].hash;
            if ($(sectionId).length > 0) {
                var gridHeaderHeight = $gridheading.outerHeight() || 0;
                setTimeout(function () {
                    window.scroll(0, $(sectionId).offset().top - $stickyHeaderLinks.outerHeight() - gridHeaderHeight);
                }, 0);
                if (utils.mediaBreakpointDown('md')) {
                    $stickyHeader.find('.navbar-collapse').removeClass('show');
                }
            }
        });

        if (utils.mediaBreakpointDown('md')) {
            $('bodyn').off('click', '.pur-sticky-header .header-toggle-button').on('click', '.pur-sticky-header .header-toggle-button', function () {
                event.preventDefault();
                $stickyHeader.find('.navbar-collapse').toggleClass('collapse');
            });
        }

        $(document).ready(function () {
            $(function () {
                $('body').tooltip({
                    selector: '[data-toggle="tooltip"]'
                });
            });
        });
    },

    // handle PUR Renew Click
    renewPowerUpRewards: function () {
        // To Set the User Selected Magazine as Default Magazine
        let $purRenewRedesign = $('.pur-renew-redesign');
        if ($purRenewRedesign.length) {
            let $radioBtnContainer = $('#proRenewModal .pro-tile');
            $('body').on('click', '.pur-renew-redesign', function () {
                const purRenewMagazine = $(this).data('renew-id') ? $(this).data('renew-id').toLowerCase() : $('#proMagazineFormatDefaultSelection').val();
                if ($radioBtnContainer.length) {
                    $radioBtnContainer.removeClass('selected');
                    $radioBtnContainer.find('input[name=option-magazineFormat]').attr('checked', false);
                    const $selectedRadioButton = $radioBtnContainer.find('#' + purRenewMagazine);
                    $selectedRadioButton.parent().addClass('selected');
                    $selectedRadioButton.find('input[name=option-magazineFormat]').attr('checked', 'checked');
                }
            });
        }
    },

    purAddToCart: function () {
        $('body').off('click', '.pur-add-to-cart').on('click', '.pur-add-to-cart', (function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $('.grid-tile[data-pid=' + $(this).data('pid') + ']');
            }

            var membershipType = $(this).data('pur-type');
            $productContainer.attr('data-pur-product', true);

            var options = membershipType === 'pro' || membershipType === 'renew' ? productBase.getOptions($productContainer) : null;
            $productContainer.removeAttr('data-pur-product');

            var gtmData = $(this).data('gtmdata') || null;
            var gtmDetail;

            if ($(this).hasClass('pro-atc-button') || $(this).hasClass('renew-redesign-button')) {
                var optionId = JSON.parse(options)[0].selectedValueId;
                var $redesignProGtmData;
                if (optionId === 'digital') {
                    $redesignProGtmData = $('#add-pur-pro-gtm-digital');
                } else if (optionId === 'physical') {
                    $redesignProGtmData = $('#add-pur-pro-gtm-physical');
                }
                gtmData = $redesignProGtmData ? $redesignProGtmData.data('gtmdata') : null;
                gtmDetail = $redesignProGtmData ? $redesignProGtmData.data('gtmdetail') : null;
            }

            var $redesignPlayerGtmData = $('#add-pur-player-gtm');
            if ($redesignPlayerGtmData.length && $(this).hasClass('player-atc-button')) {
                gtmData = $redesignPlayerGtmData.data('gtmdata') || null;
            }

            var addToCartUrl = $(this).data('url');
            var pid = $(this).data('pid');
            addToCartUrl = utils.appendParamToURL(addToCartUrl, 'productID', pid);

            var data = {
                url: addToCartUrl,
                pid: pid,
                gtmData: gtmData,
                gtmDetail: gtmDetail,
                options: options,
                event: e
            };

            if (membershipType === 'player') {
                $('body').trigger('pur:player-enroll', data);
            } else if (membershipType === 'renew') {
                $('body').trigger('pur:pro-renew', data);
            } else {
                $('body').trigger('pur:pro-enroll', data);
            }
        }));
    },

    proItemInCartCheck: function () {
        $(document).ready(function () {
            var $subscriptionProUpsellNew = $('#subscription-pro-upsell-content');
            let $cartLink = $subscriptionProUpsellNew.find('.view-cart-link');
            var $viewCartElements = $('.view-cart-link, .pur-cart-message');
            var $joinButton = $('.js-pur-upgrade');
            if ($subscriptionProUpsellNew.length) {
                let proPrice = $('#proMembershipPrice').val();
                let isPROItemInCart = $subscriptionProUpsellNew.attr('data-pro-in-cart') === 'true';
                if (isPROItemInCart && $cartLink.length) {
                    var $proPriceContainer = $('.pro-price-container');
                    $proPriceContainer.toggleClass('d-none d-flex');
                    $viewCartElements.removeClass('d-none');
                    $joinButton.addClass('d-none');
                }
                var $proPriceCta = $('.pro-price-cta');
                $proPriceCta.removeClass('hide-cta');
                if ($subscriptionProUpsellNew.find('.card-alternate-title').length) {
                    $subscriptionProUpsellNew.find('.card-title, .card-alternate-title').toggleClass('d-none');
                }
                $subscriptionProUpsellNew.removeClass('d-none');
            } else {
                let isPROItemInCart = $('#isPROItemInCart');
                let $viewCartLink = $('.view-cart-link');
                if (isPROItemInCart.length && isPROItemInCart.val() === 'true' && $viewCartLink.length) {
                    $joinButton.addClass('d-none');
                    $viewCartElements.removeClass('d-none');
                }
                $('.pur-cta-container').removeClass('hide-cta');
            }
        });
    },
    bannerViewed: function () {
        var countCheck = 1;

        if ($('.site-wide-banner').length) {
            // updating the position count if free shipping banner is visible
            countCheck = 2;
        }

        countCheck = $('.page-designer.home-page-redesign').attr('count-update') ? parseInt($('.page-designer.home-page-redesign').attr('count-update'), 10) : countCheck;

        var $cartUpsellContentRedesign = $('#cart-pro-upsell-content-redesign');
        var $showProUpsell = $('#showProUpsellContent');
        if ($cartUpsellContentRedesign.length === 0 || ($cartUpsellContentRedesign.length && $showProUpsell.attr('data-pro-item-in-cart') !== 'true')) {
            setTimeout(() => {
                dynamicImpressionTracking(countCheck);
            }, 1000);
        }
    },
    cartPurBannerImpression: function () {
        let $self = $(this);
        $(document).on('pur:dynamicImpressionTracking', function () {
            setTimeout(() => {
                $self[0].bannerViewed();
            }, 1000);
        });
    }
};
